export default __webpack_public_path__ + "static/media/ml4.f575aa4d.png";